import React from 'react';
import PropTypes from 'prop-types';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import PartnerCharges from './PartnerCharges';
import ManagedAccountingSummary from './ManagedAccountingSummary';

const PARTNER = 'Partner';
const RECEIVABLES = 'Receivables';
const PAYABLES = 'Payables';

export default function PartnerAccounting({ shipment }) {
  const {
    _id: shipmentId,
    market: { timezone },
    managed_receivables,
    managed_payables,
    current: shipmentIsCurrent,
    currency,
  } = shipment;

  const partnerReceivables = managed_receivables.filter(
    (i) => i.payee_type === PARTNER,
  );
  const partnerPayables = managed_payables.filter(
    (i) => i.payee_type === PARTNER,
  );

  const totalReceivableRate = getLedgerTotal(partnerReceivables);
  const totalPayableRate = getLedgerTotal(partnerPayables);
  const intermodalShipmentType = isIntermodalShipmentType(shipment);

  return (
    (<div data-testid="div-d4902fee" className="">
      <ManagedAccountingSummary
        receivableTotal={totalReceivableRate}
        payableTotal={totalPayableRate}
        intermodalShipmentType={intermodalShipmentType}
        customerType={PARTNER}
        currency={currency}
      />
      <div data-testid="div-87496fbf" className="mb-8">
        <PartnerCharges
          shipmentId={shipmentId}
          timezone={timezone}
          charges={partnerReceivables}
          type={RECEIVABLES}
          total={totalReceivableRate}
          isIntermodalShipmentType={intermodalShipmentType}
          shipmentIsCurrent={shipmentIsCurrent}
        />
      </div>
      <div data-testid="div-419e65a2" className="mb-8">
        <PartnerCharges
          shipmentId={shipmentId}
          timezone={timezone}
          total={totalPayableRate}
          charges={partnerPayables}
          type={PAYABLES}
          isIntermodalShipmentType={intermodalShipmentType}
          shipmentIsCurrent={shipmentIsCurrent}
        />
      </div>
    </div>)
  );
}

PartnerAccounting.propTypes = {
  shipment: PropTypes.object,
};

function getLedgerTotal(ledgerItems = []) {
  return ledgerItems.reduce(
    (total, ledgerItem) => total + (ledgerItem.value || 0),
    0,
  );
}
